<template>
  <picture v-if="src" data-qa-id="font-previewer" class="fou-add-family-imgage-wrap">
    <img data-qa-id="font-previewer-image" class="font-style-image" :alt="familyName" :src="src" />
  </picture>
</template>

<script src="./index" />

<style>
.fou-add-family-imgage-wrap {
  display: block;
}
</style>
